const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const formatMessage = require('format-message');
const axios = require('axios');
const codeGeneration = require('../codeGeneration');

let setupCode = '';
let defineCode = '';
let loopCode = '';
let bodyCode = '';
const initializedPins = new Set(); // To track initialized pins
const definedFunctions = new Set();
const definedVariable = new Set();

class Scratch3StemSensorsBlocks {
    constructor(runtime) {
        this.runtime = runtime;
        this.lastThread = null;

        if (runtime) {
            runtime.on('PROJECT_RUN_START', () => {
                codeGeneration.onRunStart();
            });
            runtime.on('PROJECT_RUN_STOP', () => {
                codeGeneration.onRunStop();
            });
        }
    }

    _checkNewThread(util) {
        const thread = util && util.thread;
        if (thread && this.lastThread !== thread) {
            this.lastThread = thread;
            initializedPins.clear();
            definedFunctions.clear();
            definedVariable.clear();
        }
    }

    getInfo() {
        return {
            id: 'stemsensors',
            name: 'Stem Sensors',
            color1: '#18b3d6',
            blocks: [
                {
                    opcode: 'disSensor',
                    blockType: BlockType.COMMAND,
                    text: 'Connect Ultrasonic sensor (Trig 33, Echo 25)',
                    func: 'disSensor'
                },
                {
                    opcode: 'acvtDissensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'stemsensor.acvtDissensor',
                        default: 'Check distance and store the value in [varname] in [distancecm]',
                        description: 'Check the distance'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        },
                        distancecm: {
                            type: ArgumentType.STRING,
                            defaultValue: 'CM',
                            menu: 'distanceMenu'
                        }
                    }
                },
                {
                    opcode: 'checkdistance',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'stemsensor.disCheck',
                        default: 'distance of [varname] [operator] [number]',
                        description: 'Check Variable'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        },
                        operator: {
                            type: ArgumentType.STRING,
                            menu: 'operatorMenu',
                            defaultValue: '=='
                        },
                        number: {
                            type: ArgumentType.STRING,
                            defaultValue: '0'
                        }
                    }
                },
                {
                    opcode: 'cntobsensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'stemsensor.cntabsensor',
                        default: 'Connect IR Sensor [number]',
                        description: 'connect to obstacle sensor'
                    }),
                    arguments: {
                        number: {
                            type: ArgumentType.STRING,
                            menu: 'irMenu',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'acvtIrsensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'stemsensor.acvtIrsensor',
                        default: 'Check obstacle from IR Sensor [num] and store the value in [varname]',
                        description: 'Check the obstacles'
                    }),
                    arguments: {
                        num: {
                            type: ArgumentType.STRING,
                            menu: 'irMenu',
                            defaultValue: '1'
                        },
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        }
                    }
                },
                {
                    opcode: 'checkobs',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'stemsensor.checkobs',
                        default: ' presence of obstacle in [varname] == [number]',
                        description: 'Check Variable'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        },
                        number: {
                            type: ArgumentType.STRING,
                            menu: 'yesnoMenu',
                            defaultValue: 'yes'
                        }
                    }
                },
                {
                    opcode: 'cntlightsensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'stemsensor.cntlightsensor',
                        default: 'Connect light sensor [number]',
                        description: 'connect to light sensor'
                    }),
                    arguments: {
                        number: {
                            type: ArgumentType.STRING,
                            menu: 'ldrMenu',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'acvtLightsensor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'stemsensor.acvtLightsensor',
                        default: 'Check light from sensor [num] and store the value in [varname]',
                        description: 'Check light'
                    }),
                    arguments: {
                        num: {
                            type: ArgumentType.STRING,
                            menu: 'ldrMenu',
                            defaultValue: '1'
                        },
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        }
                    }
                },
                {
                    opcode: 'checklight',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'stemsensor.checklight',
                        default: ' presence of light in [varname] == [number]',
                        description: 'Check Variable'
                    }),
                    arguments: {
                        varname: {
                            type: ArgumentType.STRING,
                            defaultValue: 'name_your_variable'
                        },
                        number: {
                            type: ArgumentType.STRING,
                            menu: 'yesnoMenu',
                            defaultValue: 'yes'
                        }
                    }
                }
            ],
            menus: {
                operatorMenu: {
                    items: ['==', '>', '<', '<=', '>=', '!=']
                },
                yesnoMenu: {
                    items: ['yes', 'no']
                },
                distanceMenu: {
                    items: ['MM', 'CM', 'INCH']
                },
                irMenu: {
                    items: [
                        { text: '1 (Pin 32)', value: '1' },
                        { text: '2 (Pin 35)', value: '2' }
                    ]
                },
                ldrMenu: {
                    items: [
                        { text: '1 (Pin 34)', value: '1' },
                        { text: '2 (Pin 27)', value: '2' }
                    ]
                }
            }
        };
    }

    disSensor(args, util) {
        this._checkNewThread(util);
        const trigdisPin = '33'; // Predefined pin 33
        const echoPin = '25'; // Predefined pin 25
        if (!initializedPins.has('trigdisPin')) {
            defineCode += `#define trigPin ${trigdisPin}\n`;
            setupCode += 'pinMode(trigPin, OUTPUT);\n';
            initializedPins.add('trigdisPin');
        }
        if (!initializedPins.has('echoPin')) {
            defineCode += `#define echoPin ${echoPin}\n`;
            setupCode += 'pinMode(echoPin, INPUT);\n';
            initializedPins.add('echoPin');
        }
        this.accumulateCode(util);
        this.resetCode();
    }

    acvtDissensor(args, util) {
        this._checkNewThread(util);
        const varname = args.varname || 'distanceValue';
        const distanceUnit = args.distancecm || 'CM';
        let conversionCode = '';

        switch (distanceUnit) {
            case 'MM':
                conversionCode = 'distance = distance * 10;';
                break;
            case 'INCH':
                conversionCode = 'distance = distance / 2.54;';
                break;
            case 'CM':
            default:
                conversionCode = '';
                break;
        }

        if (!definedFunctions.has(`distance_check_${distanceUnit}`)) {
            bodyCode += `\nfloat distance_check_${distanceUnit}() {\n    float duration, distance;\n    digitalWrite(trigPin, LOW);\n    delayMicroseconds(2);\n    digitalWrite(trigPin, HIGH);\n    delayMicroseconds(10);\n    digitalWrite(trigPin, LOW);\n    duration = pulseIn(echoPin, HIGH);\n    distance = (duration * 0.0343) / 2;\n    ${conversionCode}\n    delay(100);\n    return distance;\n}\n`;
        }

        definedFunctions.add(`distance_check_${distanceUnit}`);

        if (!definedVariable.has(varname)) {
            defineCode += `float ${varname};\n`;
            loopCode += `${varname} = distance_check_${distanceUnit}();\n`;
            definedVariable.add(varname);
        }
        this.accumulateCode(util);
        this.resetCode();
    }

    checkdistance(block) {
        const variable = block.varname;
        const number = block.number;
        const operator = block.operator;
        return `${variable} ${operator} ${number}`;
    }

    cntobsensor(args, util) {
        this._checkNewThread(util);
        const sensorNumber = args.number;
        let pinNumber = '32';
        if (sensorNumber === '1') {
            pinNumber = '32';
        } else if (sensorNumber === '2') {
            pinNumber = '35';
        }

        if (!initializedPins.has(`ir_sensor_${sensorNumber}`)) {
            defineCode += `#define IR_SENSOR_${sensorNumber} ${pinNumber}\n`;
            setupCode += `pinMode(IR_SENSOR_${sensorNumber}, INPUT);\n`;
            initializedPins.add(`ir_sensor_${sensorNumber}`);
        }

        this.accumulateCode(util);
        this.resetCode();
    }

    acvtIrsensor(args, util) {
        this._checkNewThread(util);
        const sensorNum = args.num;
        const varname = args.varname;

        if (!definedVariable.has(varname)) {
            defineCode += `int ${varname};\n`;
            loopCode += `${varname} = digitalRead(IR_SENSOR_${sensorNum});\n`;
            definedVariable.add(varname);
        }

        this.accumulateCode(util);
        this.resetCode();
    }

    checkobs(block) {
        const variable = block.varname;
        let number = block.number;
        if (number === 'no') {
            number = 1;
        } else if (number === 'yes') {
            number = 0;
        }
        return `${variable} == ${number}`;
    }

    cntlightsensor(args, util) {
        this._checkNewThread(util);
        const sensorNumber = args.number;
        let pinNumber = '34';
        if (sensorNumber === '1') {
            pinNumber = '34';
        } else if (sensorNumber === '2') {
            pinNumber = '27';
        }

        if (!initializedPins.has(`ldr_sensor_${sensorNumber}`)) {
            defineCode += `#define LDR_SENSOR_${sensorNumber} ${pinNumber}\n`;
            setupCode += `pinMode(LDR_SENSOR_${sensorNumber}, INPUT);\n`;
            initializedPins.add(`ldr_sensor_${sensorNumber}`);
        }

        this.accumulateCode(util);
        this.resetCode();
    }

    acvtLightsensor(args, util) {
        this._checkNewThread(util);
        const sensorNum = args.num;
        const varname = args.varname;

        if (!definedVariable.has(varname)) {
            defineCode += `int ${varname};\n`;
            loopCode += `${varname} = digitalRead(LDR_SENSOR_${sensorNum});\n`;
            definedVariable.add(varname);
        }

        this.accumulateCode(util);
        this.resetCode();
    }

    checklight(block) {
        const variable = block.varname;
        let number = block.number;
        if (number === 'no') {
            number = 1;
        } else if (number === 'yes') {
            number = 0;
        }
        return `${variable} == ${number}`;
    }

    accumulateCode(util) {
        codeGeneration.accumulateCode(defineCode, bodyCode, setupCode, loopCode, util);
    }

    resetCode() {
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodyCode = '';
    }

    full_reset() {
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodyCode = '';
        initializedPins.clear();
        definedFunctions.clear();
        definedVariable.clear();
    }
}

module.exports = Scratch3StemSensorsBlocks;
